import { Link, useLocation, useNavigate } from 'react-router-dom';

export default function StoreAdminPendingPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const username = location.state?.username;
  const storeCode = location.state?.store_code;

  return (
    <div
      className="admin-scope dark flex min-h-screen items-center justify-center"
      style={{ background: '#07090e' }}
    >
      {/* Ambient violet glow */}
      <div
        className="pointer-events-none fixed inset-0"
        style={{ background: 'radial-gradient(ellipse 60% 40% at 50% 0%, rgba(130,98,161,0.06) 0%, transparent 70%)' }}
      />

      <div className="relative w-full max-w-sm px-6">
        {/* Logo mark */}
        <div className="mb-8 flex flex-col items-center gap-3">
          <div
            className="flex h-12 w-12 items-center justify-center rounded-2xl"
            style={{ background: '#0d1522', boxShadow: '0 0 0 1px rgba(130,98,161,0.20), 0 0 24px rgba(130,98,161,0.08)' }}
          >
            <span className="font-mono text-lg font-bold" style={{ color: '#8262A1' }}>B</span>
          </div>
          <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-600">BOROO LIQUIDS · STORE</p>
        </div>

        {/* Card */}
        <div
          className="overflow-hidden rounded-2xl"
          style={{ background: '#0d1522', boxShadow: '0 0 0 1px rgba(255,255,255,0.07), 0 32px 64px rgba(0,0,0,0.5)' }}
        >
          <div className="px-7 py-7">
            <h1 className="text-xl font-semibold text-slate-100">승인 대기 중</h1>
            <p className="mt-1 text-sm text-slate-500">상위관리자 승인 후 로그인할 수 있어.</p>

            <div
              className="mt-6 rounded-lg px-4 py-3"
              style={{ background: 'rgba(255,255,255,0.04)', boxShadow: '0 0 0 1px rgba(255,255,255,0.08)' }}
            >
              <dl className="space-y-2 text-sm">
                <div className="flex items-center justify-between">
                  <dt className="text-slate-500">아이디</dt>
                  <dd className="font-mono text-slate-200">{username || '(정보 없음)'}</dd>
                </div>
                <div className="flex items-center justify-between">
                  <dt className="text-slate-500">매장코드</dt>
                  <dd className="font-mono text-slate-200">{storeCode || '(정보 없음)'}</dd>
                </div>
              </dl>
            </div>

            <p className="mt-4 text-xs text-amber-400">
              현재 상태: 승인 대기 — 상위관리자가 처리하면 알려줄게.
            </p>
          </div>

          <div
            className="flex items-center justify-between px-7 py-4"
            style={{ borderTop: '1px solid rgba(255,255,255,0.05)' }}
          >
            <button
              type="button"
              onClick={() => navigate('/store-admin/login')}
              className="text-xs text-slate-600 transition-colors hover:text-slate-400"
            >
              로그인 페이지로
            </button>
            <Link to="/admin/login" className="text-xs text-slate-600 transition-colors hover:text-slate-400">
              상위관리자 로그인
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
